import java from '../../assets/LangageProg/java.png';
import js from '../../assets/LangageProg/js.webp';
import python from '../../assets/LangageProg/python.png';

const typescript = 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/typescript/typescript-original.svg';

const LangageProgElements  = [
    { id: 1, path: js, title: 'JavaScript' },
    { id: 2, path: typescript, title: 'TypeScript' },
    { id: 3, path: java, title: 'Java' },
    { id: 4, path: python, title: 'Python' },
];

export default LangageProgElements;